module.exports = __webpack_public_path__ + "static/media/world_cup_banner.cf402567.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/world_cup_banner.png
// module id = 344
// module chunks = 0